import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { UploadBtn } from "@/components/admin/SermonForm";
import { field, card } from "@/components/admin/SettingsPanel";

const titleFrom = (name) => name.replace(/\.[^.]+$/, "").replace(/[_-]+/g, " ").trim();

// Upload many sermon audio/video files at once for one pastor. Each file becomes its own message.
export const BulkSermons = ({ speakers, onDone }) => {
  const [speaker, setSpeaker] = useState("");
  const [category, setCategory] = useState("sermon");
  const today = new Date().toISOString().slice(0, 10);
  const create = async (url, f) => {
    const video = f.type.startsWith("video/");
    const doc = f.type === "application/pdf" || f.type.startsWith("image/");
    const audio = !video && !doc;
    try {
      const { data } = await api.post("/sermons", { title_en: titleFrom(f.name), speaker: speaker.trim(), category, date: today, audio_url: audio ? url : "", video_url: video ? url : "", attachments: doc ? [{ url, name: f.name, type: f.type }] : [] });
      if (data?.pending) toast("Sent for approval — it will appear once a Super Admin approves it");
      onDone();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };
  return (
    <div data-testid="bulk-sermons-card" className={`${card} mt-4`}>
      <h3 className="font-display text-2xl text-[#F4EEE2]">Upload many messages at once</h3>
      <p className="mt-1 text-sm text-[#B7BFCC]">Choose the pastor, then pick all their audio, video, PDF or photo files. Each file becomes a message named after the file. You can edit titles, dates and photos afterwards.</p>
      <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-center">
        <input data-testid="bulk-sermons-speaker" list="bulk-speakers" value={speaker} onChange={(e) => setSpeaker(e.target.value)} placeholder="Pastor / speaker name" className={field} />
        <datalist id="bulk-speakers">{speakers.map((s) => <option key={s} value={s} />)}</datalist>
        <select data-testid="bulk-sermons-category" value={category} onChange={(e) => setCategory(e.target.value)} className={`${field} sm:w-48`}>
          <option value="sermon">Sermon</option>
          <option value="devotional">Devotional</option>
          <option value="music">Gospel Music</option>
          <option value="youth">Youth</option>
        </select>
        <UploadBtn multiple accept="audio/*,video/mp4,video/quicktime,video/webm,application/pdf,image/jpeg,image/png" testid="bulk-sermons-upload" label="Pick files" onDone={create} />
      </div>
    </div>
  );
};
